module.exports = __webpack_public_path__ + "0788209b3bf53a388390283b6de1db3e.svg";


//////////////////
// WEBPACK FOOTER
// ./components/icon/svg/pint.svg
// module id = gvtp
// module chunks = 0